import { toast } from "react-toastify";
import {AddAdminUserProps, EditAdminUserProps} from "../redux/actions/adminUsers.action";
import {AddRoleProps, EditRoleProps} from "../redux/actions/roles.action";
import { CompareValues, CountValues} from "../redux/reducers/dashboard.reducer";
import { PrivateApiCall, PublicApiCall } from "./interceptors";
type ErrorResponse = {
	response?: {
	  data?: any;
	};
  };
const errorCatch = (error : ErrorResponse) => {
	toast.error(error?.response?.data?.message || "Error occurred!");
	if (error.response) {
		if (error.response?.data) {
			return error.response?.data;
		}
		return error.response;
	} else {
		return error;
	}
};
/** ******************************************************************************************* */
/** ************************************** AUTH  ********************************************** */
/** ******************************************************************************************* */

export async function login(data: {token: string;}) {
  return await PublicApiCall.post('/admin/auth/signin', data)
  .then((response) => response )
  .catch((error:any) => errorCatch(error))
}

export async function forgotPasswordRequest(data: {email: string}) {
  return await PublicApiCall.post('/admin/auth/request/reset-password', data)
  .then((response) => response )
  .catch((error:any) => errorCatch(error))
}

export async function changePassword(data: {code: string, password: string, confirmPass: string, token: string}) {
  return await PublicApiCall.post('/admin/auth/set-password', data)
  .then((response) => response )
  .catch((error:any) => errorCatch(error))
}

export async function setFirstPassword(data: {password: string, token: string}) {
  return await PublicApiCall.post('/admin/auth/set-first-time-password', data)
  .then((response) => response )
  .catch((error:any) => errorCatch(error))
}




/** ******************************************************************************************* */
/** ************************************** COMPANIES  ***************************************** */
/** ******************************************************************************************* */

export async function getCompaniesAPI(query?:any) {
  return await PrivateApiCall.get(`/admin/companies/all${query}`)
  .then((response) => response )
  .catch((error:any) => errorCatch(error))
}

export async function getCompaniesListAPI() {
  return await PrivateApiCall.get(`/admin/companies/list`)
  .then((response) => response )
  .catch((error:any) => errorCatch(error))
}

export async function getCompanyAPI(uuid: string) {
    return await PrivateApiCall.get(`/admin/companies/one/${uuid}`)
    .then((response) => response )
    .catch((error:any) => errorCatch(error))
}

export async function addCompanyAPI(data: any) {
    return await PrivateApiCall.post('/admin/companies/create', data)
    .then((response) => response )
    .catch((error:any) => errorCatch(error))
}

export async function editCompanyAPI(data: any, uuid: string) {
    return await PrivateApiCall.put(`/admin/companies/update/${uuid}`, data)
    .then((response) => response )
    .catch((error:any) => errorCatch(error))
}

export async function deleteCompanyAPI(uuid: string) {
    return await PrivateApiCall.delete(`/admin/companies/delete/${uuid}`)
    .then((response) => response )
    .catch((error:any) => errorCatch(error))
}

export async function exportCompanyDataAPI(params?: any) {
    let query = ''
    if(params){
        Object.keys(params)?.map((key, i)=>{
            if(i===0){
                query = `?${key}=${params[key]}`
            }else{
                query = query + `&${key}=${params[key]}`
            }
        })
    }
    return await PrivateApiCall.get(`/admin/companies/export${query}`, {
        responseType: 'blob'
    })
    .then((response) => response )
    .catch((error:any) => errorCatch(error))
}

export async function listCompanySubscriptionAPI(uuid: string, type:string) {
  return await PrivateApiCall.get( type === 'API' ? `/admin/companySubscriptions/all-api/${uuid}` :`/admin/companySubscriptions/all/${uuid}`) 
  .then((response) => response )
  .catch((error:any) => errorCatch(error))
}

export async function addCompanySubscriptionAPI(data: any) {
  return await PrivateApiCall.post('/admin/companySubscriptions/create', data)
  .then((response) => response )
  .catch((error:any) => errorCatch(error))
}

export async function addApiCompanySubscriptionAPI(data: any) {
  return await PrivateApiCall.post('/admin/companySubscriptions/api-create', data)
  .then((response) => response )
  .catch((error:any) => errorCatch(error))
}

export async function editCompanySubscriptionAPI(data: any, uuid: string) {
  return await PrivateApiCall.put(`/admin/companySubscriptions/update/${uuid}`, data)
  .then((response) => response )
  .catch((error:any) => errorCatch(error))
}

export async function editApiCompanySubscriptionAPI(data: any, uuid: string) {
  return await PrivateApiCall.put(`/admin/companySubscriptions/api-update`, data)
  .then((response) => response )
  .catch((error:any) => errorCatch(error))
}

export async function deleteCompanySubscriptionAPI(uuid:string){
  return await PrivateApiCall.delete(`/admin/companySubscriptions/delete/${uuid}`)
    .then((response) => response )
    .catch((error:any) => errorCatch(error))
}

export async function deleteApiCompanySubscriptionAPI(uuid:string, version: number){
  return await PrivateApiCall.delete(`/admin/companySubscriptions/delete-api/${uuid}?version=${version}`)
    .then((response) => response )
    .catch((error:any) => errorCatch(error))
}

export async function downloadLiveUpdate(data: any,) {
  return await PrivateApiCall.post(`/admin/companies/count/liveUpdate`, data, {responseType: 'blob'})
  .then((response) => response )
  .catch((error:any) => errorCatch(error))
}

export async function downloadSummaryConsumed(data: any,) {
  return await PrivateApiCall.post(`/admin/companies/count/summary`, data, {responseType: 'blob'})
  .then((response) => response )
  .catch((error:any) => errorCatch(error))
}


export async function pepActivitiesTriggers(uuid: any,) {
  return await PrivateApiCall.get(`/admin/companies/${uuid}/pep-activity`, {responseType: 'blob'})
  .then((response) => response )
  .catch((error:any) => errorCatch(error))
}



export async function deleteCompany(uuid: string) {
  return await PrivateApiCall.delete(`/admin/company/delete/${uuid}`)
  .then((response) => response )
  .catch((error:any) => errorCatch(error))
}

/** ******************************************************************************************* */
/** ************************************** Company Validations  ********************************************* */
/** ******************************************************************************************* */

export async function getCompanyValidationsAPI(uuid: string ,query?:any) {
  return await PrivateApiCall.get(`/admin/validations/all/${uuid}${query}`)
  .then((response) => response )
  .catch((error:any) => errorCatch(error))
}

/** ******************************************************************************************* */
/** ************************************** TEAMS  ********************************************* */
/** ******************************************************************************************* */

export async function getTeamsAPI(uuid: string) {
  return await PrivateApiCall.get(`/admin/teams/all/${uuid}`)
  .then((response) => response )
  .catch((error:any) => errorCatch(error))
}

export async function getTeamAPI(uuid: string) {
  return await PrivateApiCall.get(`/admin/teams/${uuid}`)
  .then((response) => response )
  .catch((error:any) => errorCatch(error))
}

export async function addTeamAPI(data: any) {
  return await PrivateApiCall.post('/admin/teams/create', data)
  .then((response) => response )
  .catch((error:any) => errorCatch(error))
}

export async function editTeamAPI(data: any, uuid: string) {
  return await PrivateApiCall.put(`/admin/teams/update/${uuid}`, data)
  .then((response) => response )
  .catch((error:any) => errorCatch(error))
}

export async function deleteTeamAPI(uuid: string) {
  return await PrivateApiCall.delete(`/admin/teams/delete/${uuid}`)
  .then((response) => response )
  .catch((error:any) => errorCatch(error))
}

/** ******************************************************************************************* */
/** ************************************** USERS  ********************************************* */
/** ******************************************************************************************* */

export async function getUsersAPI(query?:any) {
  return await PrivateApiCall.get(`/admin/users/all/${query}`)
  .then((response) => response )
  .catch((error:any) => errorCatch(error))
}

export async function getUserAPI(uuid: string) {
  return await PrivateApiCall.get(`/admin/users/${uuid}`)
  .then((response) => response )
  .catch((error:any) => errorCatch(error))
}

export async function addUserAPI(data: any) {
  return await PrivateApiCall.post('/admin/users/invite-user', data)
  .then((response) => response )
  .catch((error:any) => errorCatch(error))
}

export async function editUserAPI(data: any, uuid: string) {
  return await PrivateApiCall.put(`/admin/users/update/${uuid}`, data)
  .then((response) => response )
  .catch((error:any) => errorCatch(error))
}

export async function deleteUserAPI(uuid: string) {
  return await PrivateApiCall.delete(`/admin/users/delete/${uuid}`)
  .then((response) => response )
  .catch((error:any) => errorCatch(error))
}

/** ******************************************************************************************* */
/** ************************************** ROLES  ********************************************* */
/** ******************************************************************************************* */

export async function getRolesAPI() {
  return await PrivateApiCall.get(`/admin/adminRoles/all`)
  .then((response) => response )
  .catch((error:any) => errorCatch(error))
}

export async function getRoleAPI(uuid: string) {
  return await PrivateApiCall.get(`/admin/adminRoles/${uuid}`)
  .then((response) => response )
  .catch((error:any) => errorCatch(error))
}

export async function addRoleAPI(data: AddRoleProps) {
  return await PrivateApiCall.post('/admin/adminRoles/create', data)
  .then((response) => response )
  .catch((error:any) => errorCatch(error))
}

export async function editRoleAPI(data: EditRoleProps, uuid: string) {
  return await PrivateApiCall.put(`/admin/adminRoles/update/${uuid}`, data)
  .then((response) => response )
  .catch((error:any) => errorCatch(error))
}

export async function deleteRoleAPI(uuid: string) {
  return await PrivateApiCall.delete(`/admin/adminRoles/delete/${uuid}`)
  .then((response) => response )
  .catch((error:any) => errorCatch(error))
}


/** ******************************************************************************************* */
/** ********************************* ADMIN USERS  ******************************************** */
/** ******************************************************************************************* */

export async function getAdminUsersAPI() {
  return await PrivateApiCall.get(`/admin/adminUsers/all`)
  .then((response) => response )
  .catch((error:any) => errorCatch(error))
}

export async function getAdminUserAPI(uuid: string) {
  return await PrivateApiCall.get(`/admin/adminUsers/${uuid}`)
  .then((response) => response )
  .catch((error:any) => errorCatch(error))
}

export async function addAdminUserAPI(data: AddAdminUserProps) {
  return await PrivateApiCall.post('/admin/adminUsers/invite-user', data)
  .then((response) => response )
  .catch((error:any) => errorCatch(error))
}

export async function editAdminUserAPI(data: EditAdminUserProps, uuid: string) {
  return await PrivateApiCall.put(`/admin/adminUsers/update/${uuid}`, data)
  .then((response) => response )
  .catch((error:any) => errorCatch(error))
}

export async function deleteAdminUserAPI(uuid: string) {
  return await PrivateApiCall.delete(`/admin/adminUsers/delete/${uuid}`)
  .then((response) => response )
  .catch((error:any) => errorCatch(error))
}

/** ******************************************************************************************* */
/** ********************************* VALIDATIONS  ******************************************** */
/** ******************************************************************************************* */

export async function getValidationsAPI(query?:any) {
  return await PrivateApiCall.get(`/admin/validations${query}`)
  .then((response) => response )
  .catch((error:any) => errorCatch(error))
}

export async function getAPIValidationsAPI(query?:any) {
  return await PrivateApiCall.get(`/admin/validations/api${query}`)
  .then((response) => response )
  .catch((error:any) => errorCatch(error))
}

export async function getValidationAPI(uuid: string) {
  return await PrivateApiCall.get(`/admin/validations/${uuid}`)
  .then((response) => response )
  .catch((error:any) => errorCatch(error))
}

export async function getIVAPIValidationAPI(uuid: string, query?: string) {
  const url = `/admin/validations/api/${uuid}/iv${query || ''}`
  console.log('[API] GET', url)
  return await PrivateApiCall.get(url)
  .then((response) => response )
  .catch((error:any) => errorCatch(error))
}

export async function getLEVAPIValidationAPI(uuid: string, query?: string) {
  const url = `/admin/validations/api/${uuid}/lev${query || ''}`
  console.log('[API] GET', url)
  return await PrivateApiCall.get(url)
  .then((response) => response )
  .catch((error:any) => errorCatch(error))
}

export async function getValidationArticleAPI(uuid: string, query:any) {
  return await PrivateApiCall.get(`/admin/validations/${uuid}/articles${query}`)
  .then((response) => response )
  .catch((error:any) => errorCatch(error))
}

export async function getValidationLevAPI(uuid: string) {
  return await PrivateApiCall.get(`/admin/validations/${uuid}/lev`)
  .then((response) => response )
  .catch((error:any) => errorCatch(error))
}

export async function getIvRiskSummaryAPI(uuid: string) {
  const url = `/admin/validations/${uuid}/iv/summary`
  return await PrivateApiCall.get(url)
    .then((response) => response)
    .catch((error:any) => errorCatch(error))
}

export async function getLevRiskSummaryAPI(uuid: string) {
  const url = `/admin/validations/${uuid}/lev/summary`
  return await PrivateApiCall.get(url)
    .then((response) => response)
    .catch((error:any) => errorCatch(error))
}
export async function getValidationLevArticleAPI(uuid: string, query:any) {
  return await PrivateApiCall.get(`/admin/validations/${uuid}/lev/articles${query}`)
  .then((response) => response )
  .catch((error:any) => errorCatch(error))
}

export async function getValidationHistoryIvAPI(uuid: string, ruuid: string) {
  return await PrivateApiCall.get(`/admin/validations/${uuid}/${ruuid}/iv`)
  .then((response) => response )
  .catch((error:any) => errorCatch(error))
}

export async function getValidationHistoryLevAPI(uuid: string, ruuid: string) {
  return await PrivateApiCall.get(`/admin/validations/${uuid}/${ruuid}/lev`)
  .then((response) => response )
  .catch((error:any) => errorCatch(error))
}

export async function restartValidationAPI(uuid: string) {
  return await PrivateApiCall.post(`/admin/validations/${uuid}/restart`)
  .then((response) => response )
  .catch((error:any) => errorCatch(error))
}

export async function bulkRestartDelayedValidationsAPI() {
  return await PrivateApiCall.post(`/admin/validations/bulk-restart-delayed`)
  .then((response) => response )
  .catch((error:any) => errorCatch(error))
}

export async function saveValidationAPI(uuid: string , data: any) {
  return await PrivateApiCall.post(`/admin/validations/${uuid}/iv/save`, data)
  .then((response) => response )
  .catch((error:any) => errorCatch(error))
}

export async function publishValidationAPI(uuid: string, data: any) {
  return await PrivateApiCall.post(`/admin/validations/${uuid}/iv/publish` , data)
  .then((response) => response )
  .catch((error:any) => errorCatch(error))
}

export async function deleteIvValidationByUuidAPI(uuid: string){
  return await PrivateApiCall.delete(`/admin/validations/${uuid}/iv/delete-validation`)
  .then((response) => response )
  .catch((error:any) => errorCatch(error))
}

export async function deleteLevValidationByUuidAPI(uuid: string){
  return await PrivateApiCall.delete(`/admin/validations/${uuid}/lev/delete-validation`)
  .then((response) => response )
  .catch((error:any) => errorCatch(error))
}

/** ******************************************************************************************* */
/** ********************************* DASBOARD  ******************************************** */
/** ******************************************************************************************* */

export async function compareCompaniesAPI(data: CompareValues) {
  return await PrivateApiCall.post(`/admin/dashboards/compare/companies`, data)
  .then((response) => response )
  .catch((error:any) => errorCatch(error))
}

export async function saveLevValidationAPI(uuid: string , data: any) {
  return await PrivateApiCall.post(`/admin/validations/${uuid}/lev/save`, data)
  .then((response) => response )
  .catch((error:any) => errorCatch(error))
}

export async function compareTeamsAPI(data: CompareValues) {
  return await PrivateApiCall.post(`/admin/dashboards/compare/teams`, data)
  .then((response) => response )
  .catch((error:any) => errorCatch(error))
}

export async function compareUsersAPI(data: CompareValues) {
  return await PrivateApiCall.post(`/admin/dashboards/compare/users`, data)
  .then((response) => response )
  .catch((error:any) => errorCatch(error))
}

export async function compareValidationsAPI(data: CompareValues) {
  return await PrivateApiCall.post(`/admin/dashboards/compare/validations` , data)
  .then((response) => response )
  .catch((error:any) => errorCatch(error))
}

export async function countValidationsAPI(data: CountValues) {
  return await PrivateApiCall.post(`/admin/dashboards/count/validations` , data)
  .then((response) => response )
  .catch((error:any) => errorCatch(error))
}

export async function countLiveUpdateAPI(data: CountValues) {
  return await PrivateApiCall.post(`/admin/dashboards/count/liveUpdate` , data) 
  .then((response) => response )
  .catch((error:any) => errorCatch(error))
}

export async function publishLevValidationAPI(uuid: string, data: any) {
  return await PrivateApiCall.post(`/admin/validations/${uuid}/lev/publish` , data)
  .then((response) => response )
  .catch((error:any) => errorCatch(error))
}

export async function getOverview(query?:any) {
  return await PrivateApiCall.get(`/admin/dashboards/overview${query}`)
  .then((response) => response )
  .catch((error:any) => errorCatch(error))
}

export async function getCmsCuratedLinks(query?:any) {
  return await PrivateApiCall.get(`/admin/dashboards/cms-curated-links${query}`)
  .then((response) => response )
  .catch((error:any) => errorCatch(error))
}

export async function getAvgReportingTime(query?:any) {
  return await PrivateApiCall.get(`/admin/dashboards/avg-reporting-time${query}`)
  .then((response) => response )
  .catch((error:any) => errorCatch(error))
}


/** user methods */
export async function saveCurrentUser(data: any) {
  return await PrivateApiCall.put('/admin/auth/update-settings', data)
  .then((response) => response )
  .catch((error:any) => errorCatch(error))
}


export async function updateCurrentPwd(data: any) {
  return await PrivateApiCall.post('/admin/auth/change-password', data)
  .then((response) => response )
  .catch((error:any) => errorCatch(error))
}


export async function getAPIUsersAPI(uuid:string) {
  return await PrivateApiCall.get(`/admin/dev-portal/users/${uuid}`)
  .then((response) => response )
  .catch((error:any) => errorCatch(error))
}

export async function addAPIUserAPI(data: any) {
  return await PrivateApiCall.post('/admin/dev-portal/users', data)
  .then((response) => response )
  .catch((error:any) => errorCatch(error))
}

/** ******************************************************************************************* */
/** ********************************* LIVE UPDATE VALIDATIONS  ******************************************** */
/** ******************************************************************************************* */

export async function restartLiveUpdateValidationAPI(uuid: string) {
  return await PrivateApiCall.post(`/admin/validations/live-updates/${uuid}/restart`)
  .then((response) => response )
  .catch((error:any) => errorCatch(error))
}

export async function bulkRestartDelayedLiveUpdateValidationsAPI() {
  return await PrivateApiCall.post(`/admin/validations/live-updates/bulk-restart-delayed`)
  .then((response) => response )
  .catch((error:any) => errorCatch(error))
}

export async function getLiveUpdateValidationsAPI(query?:any) {
  return await PrivateApiCall.get(`/admin/validations/live-updates${query}`)
  .then((response) => response )
  .catch((error:any) => errorCatch(error))
}